export default "__VITE_ASSET__CFwufAMD__"